import { useI18n } from "../contexts/LanguageContext";
import { LogIn } from "lucide-react";

export default function Login() {
  const { t } = useI18n();

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard/profile";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="container-pad mx-auto max-w-md py-24" data-testid="page-login">
      <div className="bg-white border border-slate-100 rounded-[24px] p-8 md:p-10 shadow-soft text-center">
        <img src="/logo.jpg" alt="ENCES Global" className="w-16 h-16 rounded-2xl mx-auto object-cover" />
        <h1 className="mt-5 text-2xl font-extrabold text-navy">{t.auth.signIn}</h1>
        <p className="mt-2 text-slate-600 text-sm">Welcome to ENCES Global</p>
        <button onClick={handleGoogle} className="mt-7 w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-navy hover:bg-navy/90 text-white font-semibold" data-testid="google-login-button">
          <LogIn size={16} /> {t.auth.google}
        </button>
      </div>
    </div>
  );
}
